var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { StyledInput } from './style';
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = React.createRef();
        return _this;
    }
    Input.prototype.render = function () {
        return React.createElement(StyledInput, __assign({}, this.props, { ref: this.inputRef }));
    };
    Input.propTypes = {
        error: PropTypes.bool,
        success: PropTypes.bool,
        warning: PropTypes.bool,
        spellCheck: PropTypes.bool,
        bold: PropTypes.bool,
        type: PropTypes.string,
    };
    return Input;
}(React.Component));
export default Input;
//# sourceMappingURL=index.js.map